// extracted by mini-css-extract-plugin
export default {"referral-widget":"bo","referral-page":"co","label":"eo","subHed":"fo","profile-container":"go","referral-container":"ho","referral-header":"io","shareMethodRow":"jo","shareMethod":"ko","active":"lo","referral-stat":"mo","blockwrapper":"no","referralLink":"oo","bold":"po","semibold":"qo","shareAgainButton":"ro","policy":"so","narrowWrapper":"to"};
    if(module.hot) {
      // 1715091669207
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  